module.exports = __webpack_public_path__ + "media/images/emblems/Allmendingen-coat_of_arms-241ca7b2774e928b88029b3446923841.svg";